import { FC } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { SaunaIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { Grid, InputLabel } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";

export const IncreaseCurrentElectricSaunaForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.INCREASE_CURRENT_ELECTRIC_SAUNA>();
    return (
        <BoxedInputWithIconAndOptionalSwitch
            icon={<SaunaIcon />}
            content={
                <p className={classes.label} style={{ marginBottom: 8 }}>
                    Sauna
                </p>
            }
            useSwitch={
                <Switch
                    checked={values.increaseCurrentElectricSauna.value.installed}
                    {...getFieldProps("increaseCurrentElectricSauna.value.installed")}
                    onChange={(e, checked) =>
                        setValues((values) => {
                            values.increaseCurrentElectricSauna.value.installed = checked;
                            values.increaseCurrentElectricSauna.value.demand.amount = checked
                                ? 0
                                : null;
                        })
                    }
                />
            }
            detailCondition={values.increaseCurrentElectricSauna.value.installed}
            detail={
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            decimalScale={values.increaseCurrentElectricSauna.value.demand.precision}
                            allowLeadingZeros={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.increaseCurrentElectricSauna.value.demand.unit}
                            value={values.increaseCurrentElectricSauna.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.increaseCurrentElectricSauna.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.increaseCurrentElectricSauna.error != null}
                        />

                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            style={{ marginTop: -12 }}
                            isCheckBox={true}
                            control={
                                <Checkbox
                                    value="ja"
                                    checked={
                                        values.increaseCurrentElectricSauna.value
                                            .notKnown
                                    }
                                    onChange={(event, checked) =>
                                        setValues((values) => {
                                            values.increaseCurrentElectricSauna.value.notKnown =
                                                checked;
                                        })
                                    }
                                />
                            }
                            label="Leistungswert nicht bekannt"
                            error={false}
                        />
                    </Grid>
                </Grid>
            }
        />
    );
};
